var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [
          _vm._v(_vm._s(_vm.$t("application.messages.simpleAppMethod.title"))),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("application.messages.simpleAppMethod.subtitle")) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "col-6" }, [
            _c("p", [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t(
                      "application.messages.simpleAppMethod.referrerSpecific"
                    )
                  ) +
                  "\n          "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-6 inline-actions" },
            [
              _c("referrers-select", {
                attrs: {
                  "has-checkboxes": false,
                  "allow-create": false,
                  value: _vm.selectedReferrer,
                  "allow-clear": "",
                },
                on: { change: _vm.updateReferrer },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "bar" }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "col-6" }, [
            _c("p", [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t(
                      "application.messages.simpleAppMethod.languageSpecific"
                    )
                  ) +
                  "\n          "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-6 d-flex" },
            [
              _c("lang-selector", {
                staticClass: "mb-3",
                attrs: {
                  "locale-model": _vm.customLocale,
                  "with-confirmation": false,
                },
                on: {
                  "update:localeModel": function ($event) {
                    _vm.customLocale = $event
                  },
                  "update:locale-model": function ($event) {
                    _vm.customLocale = $event
                  },
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters align-items-center" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "form-group-material" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  id: "link-client",
                  readonly: "",
                  type: "text",
                  placeholder: "Copy link",
                },
                domProps: { value: _vm.simpleApplicationLink },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "link-client" } },
                [_vm._v(_vm._s(_vm.$t("settings.accountTab.siteURL")))]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "bar" }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-auto" }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-center mt-3" }, [
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "white" },
              on: {
                click: function ($event) {
                  return _vm.$emit("hide")
                },
              },
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("global.words.close")) + "\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-6 d-flex justify-content-end align-items-center" },
        [
          _c(
            "a",
            {
              staticClass: "clickable back-from-option mr-3",
              on: { click: _vm.handleBack },
            },
            [
              _c("i", {
                staticClass: "fa fa-long-arrow-left pr-2",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(
                "\n        " + _vm._s(_vm.$t("global.words.back")) + "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { id: "copyLink", type: "button" },
              on: { click: _vm.copyLink },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("application.actions.copyLink")) +
                  "\n      "
              ),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }